import { TopBar } from "@/components/shell/TopBar";
import { LeftRail } from "@/components/shell/LeftRail";
import { useShellActive } from "@/components/shell/useShell";

export const SuiteShell = ({ children }) => {
  const active = useShellActive();
  if (!active) return children;
  return (
    <div className="suite-shell min-h-screen bg-background" data-testid="suite-shell">
      <TopBar />
      <LeftRail />
      <div className="md:pl-20">{children}</div>
    </div>
  );
};
